var PREFIX = "BOTTOM_TABS.";
// ACTION TYPES
export var OPEN_BOTTOM_TAB = PREFIX + "OPEN_BOTTOM_TAB";
export var CLOSE_BOTTOM_TAB = PREFIX + "CLOSE_BOTTOM_TAB";
export var REORDER_TABS = PREFIX + "REORDER_TABS";
export var SET_BOTTOM_TAB_INDEX = PREFIX + "SET_BOTTOM_TAB_INDEX";
